<template>
  <div class="footer" :class="search ? 'fiexBottom' : ''">
    <p>
      <span>备案号：<a href='http://beian.miit.gov.cn' target="_blank">苏ICP备19049108号</a></span>
      <span>|</span>
      <span><img class="beianImg" src="../../../src/assets/img/beian.png" />苏公网安备 32010402000846号</span>
      <span>|</span>
      <span>客户服务热线：0515-88200000</span>
      <br />
      <span>违法和不良信息举报电话：0515-88200000</span>
      <span>|</span>
      <span>举报邮箱：2895915959@qq.com</span>
    </p>
    <p>版权所有©南京万知园信息工程有限公司 万知网</p>
    <p>接洽：江苏省盐城市通港路11号综合楼一楼1号</p>
    <div class="scrollTop" v-show="showTop" @click="gotop"><i class="el-icon-arrow-up"></i>顶部</div>
  </div>
</template>

<script>
export default {
  props: {
    search: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      scrollTop: 0
    }
  },
  computed: {
    showTop: function () {
      let value = this.scrollTop > 1000
      return value
    }
  },
  methods: {
    gotop () {
      // 这是最简单的回到顶部代码，但是过渡非常生硬，不建议这样写
      // document.documentElement.scrollTop = document.body.scrollTop = 0
      // 这里的原理是用定时器每200毫秒执行一次函数，每一次滚轮px减50，直到0为止
      let back = setInterval(() => {
        if (document.documentElement.scrollTop || document.body.scrollTop) {
          // document.documentElement.scrollTop -= 50
          // document.body.scrollTop -= 50
          document.documentElement.scrollTop = 0
          document.body.scrollTop = 0
        } else {
          clearInterval(back) // scrollTop到0时就移除定时器
        }
      }, 200)
    },
    getScrollTop () {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    }
  },
  mounted () {
    // addEventListener() 方法来添加监听事件
    window.addEventListener('scroll', this.getScrollTop)
  }
}
</script>

<style scoped>
.footer {
  height: 150px;
  background: #ff7e00;
  overflow: hidden;
  font-size: 14px;
}
.fiexBottom {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
}
.footer p {
  text-align: center;
  color: #fff;
  line-height: 30px;
}
.footer p span {
  padding: 0 5px;

}
.beianImg {
  display: block;
  width: 20px;
  float: left;
  margin-top: 5px;
}
.footer p:first-child {
  margin-top: 20px;
}
.back-test {
  width: 300px;
  height: 300px;
  background: rebeccapurple;
  margin: 20px 20px 20px auto;
}
.scrollTop {
    position: fixed;
    right: 10px;
    bottom: 80px;
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: red;
    padding-top: 20px;
    box-sizing: content-box;
    z-index: 99;
}
.scrollTop i {
  display: block;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TourFooter.vue